// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"37":"Homepage","72":"Cart","238":"ContainersDetails","985":"Containers"}[chunkId] || chunkId) + "." + {"37":"6e546b5c","72":"2ecb1262","238":"69153edb","243":"f2fc9aa1","985":"5a83ed70"}[chunkId] + ".chunk.js";
};